import { get } from 'app/utils/axios/kheti'
import { DemoMaterialRequest } from 'app/models/RequestFlow'

const fetchDemoMaterialRequestDetail = async (requestId: number) => {
  return get<DemoMaterialRequest>(
    `/approvals/v1/demo-material-issuance/requests/${requestId}`,
  )
}

export default fetchDemoMaterialRequestDetail
